<template>
	<div
		class="profile-list-container"
		:class="{ condensed, clickable }"
		:style="cssVars"
	>
		<transition-group
			class="profile-pic-list"
			name="profile-list"
			tag="span"
			@click="$emit('click', $event)"
		>
			<ProfilePic
				v-for="(user, i) in list"
				:key="user.id"
				:user="user"
				:size="size"
				:enableOnline="enableOnline"
				:onlineSize="onlineSize"
				:style="{ '--z': i }"
			/>
		</transition-group>
		<span
			v-if="moreCount > 0"
			class="profile-list-more"
			v-text="$t('announcements_group_selected_seemore', [moreCount])"
		/>
	</div>
</template>

<script>
import { ProfilePic } from '@/components/common'
import { getUser } from '@/store'

export default {
	name: 'ProfileList',
	components: { ProfilePic },
	emits: ['click'],
	props: {
		userIds: Array,
		condensed: { type: Boolean, default: null },
		max: {
			type: Number,
			default: 18,
		},
		size: {
			type: String,
			default: '20px',
		},
		enableOnline: {
			type: Boolean,
			default: null,
		},
		clickable: {
			type: Boolean,
			default: null,
		},
		onlineSize: {
			type: String,
			default: '15px',
		},
	},
	computed: {
		list() {
			if (!this.userIds) return []
			return this.userIds
				.map(getUser)
				.filter((u) => u)
				.slice(0, this.max)
		},

		moreCount() {
			return this.userIds.length - this.max
		},

		cssVars() {
			return { '--size': this.size }
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.profile-list-container {
	@include flex;
	> * {
		flex-shrink: 0;
	}
	&.clickable {
		cursor: pointer;
		padding: 2px 4px;
		border-radius: calc(var(--size) / 2);
		&:hover {
			background: $light-blue;
		}
	}
	&.condensed {
		.profile-pic-list {
			.profile-pic-avatar {
				// in condensed mode, we want each profile to overlap by 1/3 so we set
				// a negative left margin based on the --size
				margin-left: calc(var(--size) / 3 * -1);
				// in order to make it so the first avatar appear to overlap "on top"
				// of the others, we have to set an explicit z-index on each one
				z-index: var(--z);
				&:first-child {
					margin-left: 0;
				}
			}
		}
	}
	.profile-pic-list {
		@include flex;
		.profile-pic-avatar {
			margin-left: 2px;
			&:first-child {
				margin-left: 0;
			}
		}
	}
	.profile-list-more {
		font-family: Avenir-Roman;
		font-size: 12px;
		color: var(--blue-300);
		margin-left: 3px;
	}
}

@keyframes bounce {
	0% {
		width: 0;
		opacity: 0.2;
		transform: scale(0) transformY(0);
	}
	50% {
		opacity: 1;
		width: 20px;
	}
	100% {
		transform: scale(1) transformY(0);
	}
}

.profile-list-enter-active {
	animation: bounce 0.3s cubic-bezier(1, 0, 0.32, 1.5);
}
.profile-list-leave-active {
	animation: bounce 0.3s linear reverse;
}
</style>
